import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const bookItemsApi = createApi({
  reducerPath: 'bookItemsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_CONNECT}/`,
  }),

  tagTypes: ['BookItem'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    getBookById: builder.query({
      query: (data) => {
        return {
          url: `book_items/${data.id}/${data.language}`,
          method: 'GET',
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['BookItem'],
    }),

    updateBook: builder.mutation({
      query: (data) => {
        return {
          url: `book_items/${data.id}/${data.language}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),

    // update book image
    updateImage: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.image_file);
        return {
          url: `book_items/${data.book_id}/${data.id}/${data.language}`,
          method: 'POST',
          body: formData,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),



    createSummary: builder.mutation({
      query: (data) => {
        return {
          url: `summaries/${data.id}/${data.language}`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),


    updateSummary: builder.mutation({
      query: (data) => {
        return {
          url: `summaries/${data.id}/${data.language}`,
          method: 'PUT',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),


    updateAudio: builder.mutation({
      query: (data) => {
        const formData = new FormData();
        formData.append("myFile", data.audio_file);
        return {
          url: `summaries/${data.book_id}/${data.book_item_id}/${data.id}/${data.language}`,
          method: 'PUT',
          body: formData,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),


    deleteSummary: builder.mutation({
      query: (data) => {
        return {
          url: `summaries/${data.id}/${data.language}`,
          method: 'DELETE',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),


    // conver media file to hls
    convertMedia: builder.mutation({
      query: (data) => {
        return {
          url: `summaries`,
          method: 'POST',
          body: data,
          headers: {
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'X-User-Role': data.userRole,
            'Accept': 'application/json',
            'Content-type': 'application/json; charset=UTF-8',
          }
        }
      },
      // keepUnusedDataFor: 1,
      invalidatesTags: ['BookItem'],
    }),






  }),
})

// Export hooks for usage in functional components, which are auto-generated based on the defined endpoints
export const {
  useUpdateBookMutation,
  useUpdateImageMutation,
  useGetBookByIdQuery,
  useCreateSummaryMutation,
  useUpdateSummaryMutation,
  useDeleteSummaryMutation,
  useUpdateAudioMutation,
  useConvertMediaMutation
} = bookItemsApi